import { NgModule } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { AutomatedUserManagementBannerComponent } from './banner.component';

@NgModule({
  declarations: [AutomatedUserManagementBannerComponent],
  exports: [AutomatedUserManagementBannerComponent],
  imports: [FlexLayoutModule, MatButton, MatIconModule],
})
export class AutomatedUserManagementBannerModule {}
